const markAllViewed = async (instance) => {
  const response = await instance.get("/api/notification/markAllViewed");
  return response.status === 200;
};
const changeLocale = async (instance, idioma) => {
  const response = await instance.post("/api/user/changeLocale", idioma, {
    headers: {
      "Content-Type": "text/plain"
    }
  });
  return response.data;
};
const setSeen = async (instance, id) => {
  const response = await instance.post("/api/onboarding/seen", id, {
    headers: {
      "Content-Type": "text/plain"
    }
  });
  return response.status === 200;
};

export { changeLocale, markAllViewed, setSeen };
